import React from "react";
import {
  Icon,
  Text,
  Box,
  Heading,
  List,
  ListItem,
  Flex,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import FeatureLockModal from "../../featureLockModal/FeatureLockModal";
import PropTypes from "prop-types";
import { includedFeatures } from "apps/simplified-web/src/_utils/constants";
import { useState } from "react";
import TldrTrialEndedModal from "apps/simplified-web/src/TldrSettings/TldrBillingAndPayments/Modals/TldrTrialEndedModal";

const TldrUpgradeSubscriptionModal = ({
  featureList,
  image,
  onHide,
  title,
  selectedPlanName,
  subtitle,
}) => {
  const [showChoosePlanAndPayModal, setShowChoosePlanAndPayModal] =
    useState(false);
  const { t } = useTranslation(["accounts"]);
  function viewAllPlans() {
    setShowChoosePlanAndPayModal(true);
  }

  function onClose() {
    onHide();
  }

  return (
    <FeatureLockModal
      onCancel={onClose}
      onConfirm={viewAllPlans}
      cancelButtonText={t("upgrade_modal.button.cancel")}
      confirmButtonText={t("choose_plan", { ns: "common" })}
      image={
        image || "https://assets.simplified.co/images/upgrade-plan-modal.png"
      }
    >
      <Box flex="1">
        <Heading size="md" mb="3" color="white">
          {title || t("upgrade_modal.title")}
        </Heading>
        <Text mb="8" color="gray.100" fontSize="sm">
          {subtitle || t("upgrade_modal.subtitle")}
        </Text>
        <List spacing="4" mb="4">
          {featureList.length > 0 &&
            featureList.map((feature, idx) => (
              <ListItem key={idx}>
                <Flex>
                  <Icon
                    as={feature.icon}
                    color="brand.primary"
                    fontSize="2xl"
                    mr="3"
                  />
                  <Box>
                    <Heading
                      size="md"
                      fontSize="md"
                      mb="1"
                      as="h3"
                      color="white"
                    >
                      {feature.title}
                    </Heading>
                    <Text color="gray.100" fontSize="sm">
                      {feature.info}
                    </Text>
                  </Box>
                </Flex>
              </ListItem>
            ))}
        </List>
      </Box>
      {showChoosePlanAndPayModal && (
        <TldrTrialEndedModal
          show={showChoosePlanAndPayModal}
          onHide={() => {
            setShowChoosePlanAndPayModal(false);
            onClose();
          }}
          selectedPlanName={selectedPlanName}
        />
      )}
    </FeatureLockModal>
  );
};

TldrUpgradeSubscriptionModal.propTypes = {
  featureList: PropTypes.array,
  selectedPlanName: PropTypes.string,
};

TldrUpgradeSubscriptionModal.defaultProps = {
  featureList: [...includedFeatures],
  selectedPlanName: undefined,
};

export default TldrUpgradeSubscriptionModal;
